// removed by extract-text-webpack-plugin
module.exports = {"root":"_3Q63ivP","content":"_2lbrlNw","suburbs":"waL6Suy","heading":"NkFsDmd","link":"q_zUcZK","toggleLabel":"_3aGowg1","toggle":"_2Pys8P9","chevron":"_13anlbj","chevronSvg":"_2AW97yb","toggleContent":"_1jzyKIn","more":"_2a0PsDb","less":"_1ZPA2s0"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/Suburbs/Suburbs.less
 ** module id = 873
 ** module chunks = 0
 **/